import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../utilities/LocalizationModule";

export interface ICMConfirmModalProps {
    message: string;
    showDialog: boolean;
    closeDialog: () => void;
}

export const CMErrorModal = ({ message, showDialog, closeDialog }: ICMConfirmModalProps) => {
    const languageStrings = React.useContext(LanguageContext);

    const dialogContentProps: IDialogContentProps = {
        type: DialogType.normal,
        title: languageStrings.Error,
        subText: message,
        showCloseButton: true,
        closeButtonAriaLabel: 'Close'
    };

    return (
        <Dialog hidden={!showDialog} onDismiss={() => closeDialog()} dialogContentProps={dialogContentProps} >
            <DialogFooter>
                <DefaultButton autoFocus onClick={() => closeDialog()} text={languageStrings.Close} />
            </DialogFooter>
        </Dialog>
    )
};